module.exports = __webpack_public_path__ + "media/images/lb/233-e5fd6982a1f0c2aa0f20a0e48197e272.svg";